<template>
  <div class="record-page">
    <comTable class="table-box" @selectedDatafn="selectedDatafn" :config="tableConfig" ref="table"></comTable>
  </div>
</template>

<script>
  import comTable from "@/components/comTable.vue";
	export default {
    components: {
      comTable
    },
		data() {
			return {
        checKData: [],
        tableConfig: {
          url: "checkLogs",
          pr: {
            config_name: 'ai_check_conf'
          },
          list: [
            { label: "修改时间", prop: "update_at" },
            { label: "备注", prop: "edit_desc" }
          ]
        }
      }
    },
    methods: {
      selectedDatafn(da) {
        this.checKData = da;
      },
    }
  }
</script>

<style lang="scss">
  .record-page {
    .table-box {
      .el-table__body-wrapper {
        height: 76vh !important;
      }
    }
  }
</style>